import React, { useEffect } from 'react';
import DialogModal from '../../utils/DialogModal';


const DestinationErrorDialog = ({ open }: { open: boolean }) => {

    return (
        <DialogModal open={open} onClose={() => { }} iconClass={"exclam"} buttonCancel={"CANCEL"} buttonOk={"TRY AGAIN"}>
            <>
                <p>
                    An error occured while trying to livestream to your destinations. Please make sure you&apos;re logged into your social channels, check your destination settings
                </p>
            </>
        </DialogModal>
    )
}

export default DestinationErrorDialog;
